<!--
 * @Author: 王佳宾
 * @Date: 2022-08-09 17:36:14
 * @LastEditors: chenmengnan
 * @LastEditTime: 2026-08-19 13:44:01
 * @Description:
 * @FilePath: \web\src\components\lib\Modal\modal.vue
-->
<template>
  <section>
    <a-modal v-model:visible="option.visible" width="100%" wrap-class-name="full-modal zIndex600" :class="{ max: !loading }" :maskStyle="{'z-index': '499'}" 
      :footer="null" :getPopupContainer="(triggerNode) => triggerNode.parentNode" :closable="false"
      :destroyOnClose="true">
      <a-spin :spinning="loading" size="large">
        <!-- <template #title>
        <div ref="modalTitleRef" style="width: 100%; cursor: move">重点项目</div>
        </template> -->
        <section v-if="!loading & !modalTypeDrill">
          <section class="popup-btns" v-if="modalType === 'add'">
            <!-- <section class="popup-btn" @click="editPopup">编辑</section> -->
            <!-- <section class="popup-btn" @click="editPopup">编辑</section> -->
            <section class="popup-btn" @click="beforeAddConfirm">提交</section>
            <section class="popup-btn" @click="goBack">返回</section>
          </section>


          <section class="popup-btns" v-else-if="modalType === 'default' && routeType === 'default'
          ">
            <section class="popup-btn" @click="changeFollowFlag(false)"
              v-if="modalContrast ? !dataList[0].propInfoEntity.followFlag : !dataList.propInfoEntity.followFlag">关注
            </section>
            <section class="popup-btn" @click="changeFollowFlag(true)"
              v-if="modalContrast ? dataList[0].propInfoEntity.followFlag : dataList.propInfoEntity.followFlag">取消关注
            </section>
            <!-- <section class="popup-btn" @click="editPopup">编辑</section> -->
            <!-- <section class="popup-btn" @click="editPopup">编辑</section> -->
            <section class="popup-btn" @click="beforeEditConfirm" v-if="showEdit">确认编辑</section>
            <section class="popup-btn" @click="editClose" v-if="showEdit">取消编辑</section>
            <section class="popup-btn" @click="editPopup"
              v-else-if="!showEdit && (config.getPermissionId() == 1 || config.getPermissionId() == 2)">编辑
            </section>
            <!-- <section :class="bgType == 'yes' ? 'popup-btn' : 'popup-btn bgType'" @click="previewPdf">项目报告</section>
            <section
              :class="dataList.propInfoEntity.holeFlag == '1' ? 'popup-btn' : 'popup-btn bgType'"
              @click="jumpDrill"
            >
              钻孔信息
            </section> -->
            <section class="popup-btn" @click="goBack">返回</section>
          </section>
          <section class="popup-btns" v-else-if="modalType === 'default' && routeType === 'audit'">
            <section class="popup-btn" @click="beforeEditConfirm" v-if="showEdit">确认编辑</section>
            <section class="popup-btn" @click="editClose" v-if="showEdit">取消编辑</section>
            <section class="popup-btn" @click="editPopup" v-else>编辑</section>
            <section class="popup-btn" @click="goBack">返回</section>
          </section>
          <section class="popup-btns" v-else>
            <section class="popup-btn" @click="goBack">返回</section>
          </section>

          <section class="popup-header" v-if="modalType === 'default'">
            <section class="popup-header-title">
              <span class="popup-header-title-name">{{
                getProjectTitle(modalContrast ? dataList[0][projectDetailList[0].type] :
                  dataList[projectDetailList[0].type])
              }}</span>
              <span class="popup-header-title-project">{{
                modalContrast ? dataList[0][projectDetailList[0].type].propertyLevel :
                  dataList[projectDetailList[0].type].propertyLevel
              }}</span>
            </section>
          </section>
          <!-- / s -->

          <Edit v-if="modalType === 'add'" ref="addChild" :dataList="addDetailRequest"
            :projectDetailList="projectDetailList" />
          <!-- / 新增 -->

          <section class="popup-content" v-else-if="!showEdit">
            <section v-for="(item, index) in projectDetailList" :key="item.title" :class="item.className"
              class="popup-item">
              <section class="popup-index">
                <span>0{{ index + 1 }}</span>
              </section>
              <!-- / 右上角标题 -->

              <h4>{{ item.title }}</h4>
              <!-- / 标题 -->

              <ul>
                <li v-for="i in item.children" :key="i.title">
                  <span class="title" :class="i.className">{{ i.title }}：</span>
                  <div class="value" :class="i.className">
                    <!-- {{ dataList[i.type] }} -->
                    <a-tooltip v-if="modalContrast" placement="top" class="tooltip-hidden"
                      :getPopupContainer="(triggerNode) => triggerNode.parentNode">
                      <template #title>
                        <span v-html="getContrast(i, item)"></span>
                      </template>
                      <a :href="getHref(getValue(dataList[0], i, item))" v-if="i.isLink" target="_blank"
                        style="color: blue">{{
                          getContrast(i, item)
                        }}</a>

                      <span v-else v-html="getContrast(i, item)"> </span>
                    </a-tooltip>
                    <a-tooltip v-else placement="top" class="tooltip-hidden"
                      :getPopupContainer="(triggerNode) => triggerNode.parentNode">
                      <template #title>
                        <span v-html="getValue(dataList, i, item)"></span>
                      </template>
                      <a :href="getHref(getValue(dataList, i, item))" v-if="i.isLink" target="_blank"
                        style="color: blue">{{
                          getValue(dataList, i, item)
                        }}</a>

                      <span v-else v-html="getValue(dataList, i, item)"></span>
                    </a-tooltip>
                  </div>
                </li>
              </ul>
              <!-- / 详情 -->
            </section>
          </section>
          <!-- / 展示 -->

          <Edit v-else ref="editChild" :dataList="modalContrast ? dataList[0] : dataList"
            :projectDetailList="projectDetailList" />
          <!-- / 编辑 -->

          <ConfirmModal :option="confirmModalConf" @confirm="confirm" @close="close">
            <template v-slot:main>
              <FileUpload v-if="confirmModalConf.type === 'upload'" @fileList="importFileList" uploadType=".pdf" />
              <div v-else-if="confirmModalConf.type === 'confirm'"></div>
              <a-textarea v-else placeholder="请填写备注" v-model:value="confirmModalConf.remark" :rows="8" />
            </template>
          </ConfirmModal>
          <!-- / 操作弹出框 -->
          <!--
          <a-modal
            v-model:visible="editVisible"
            :title="null"
            @ok="editConfirm"
            :closable="false"
            :destroyOnClose="true"
            :confirm-loading="editLoading"
          >
            <p>确认提交审核？</p>
            <a-textarea v-model:value="editRemark" placeholder="请填写备注" :rows="4" />
          </a-modal> -->
          <section class="popup-bottom-btns" v-if="modalType === 'default' && routeType === 'default'
          ">
            <section :class="prejectPrompt.className" @click="prejectPrompt.callback">
              {{ prejectPrompt.title }}
            </section>
            <section
              :class="modalContrast ? (dataList[0].propInfoEntity.holeFlag == '1' ? 'popup-btn' : 'popup-btn bgType') : (dataList.propInfoEntity.holeFlag == '1' ? 'popup-btn' : 'popup-btn bgType')"
              @click="jumpDrill">
              钻孔信息
            </section>
          </section>
        </section>
        <section v-else-if="modalTypeDrill">

          <section class="popup-btns">
            <section class="popup-btn" @click="goBackDetailMsg">返回</section>
          </section>
          <section class="popup-content"
            style="width:100%;height:calc(100vh - 1.45rem);overflow: hidden;margin-top: 1rem;">

            <DrillTable :modalDrillParams="modalDrillParams" />
          </section>
        </section>
      </a-spin>
    </a-modal>
  </section>
</template>

<script setup>
import { defineProps, toRefs, onMounted, ref, reactive, defineEmits, watch, h, } from 'vue';
import { operationSubmit, followProjectApi, cancelProjectApi, } from '@/api/dataManagement/dataManage';
import Edit from '@/components/lib/Modal/modalChild/edit.vue';
import ConfirmModal from '@/components/lib/Modal/modal1.vue';
import config from '@/config/config';
import { transMoney, fixedValue, } from '@/utils/utils';
import { getPdfUrlApi, getPdfUrlApiAjax, uploadReportApi, removeReportApi, getReportAddrApi } from '@/api/utils/utilsApi';
import { message, } from 'ant-design-vue';
import { useRouter, useRoute, } from 'vue-router';
import { useStore, } from 'vuex';
import store from '@/store/index';
import FileUpload from '@/components/lib/Upload/fileUpload.vue';
import DrillTable from "./modalChild/drillTable.vue";

const router = useRouter();
const route = useRoute();

const { state, dispatch: storeDispatch, commit: storeCommit, } = useStore();
// 重写commit
const commit = (space, methods, params) => storeCommit(`${space || 'drillLibrary'}/${methods}`, params);
const editOperationCof = [1, 2,];
const reportImgAddr = ref('')
const bgType = ref('yes');
const modalTypeDrill = ref(false)
const modalDrillParams = reactive({
  propName: null,
  propId: null,
  globalRegion: null,
  countryName: null,
})
// 定义
const props = defineProps({
  option: {
    type: Object,
  },
  loading: {
    type: Boolean,
    default: true,
  },
  dataList: {
    type: Object,
    default: () => ({}),
  },
  modalType: {
    type: String,
    default: 'default',
  },
  modalContrast: {
    type: Boolean,
    default: false,
  },
  routeType: {
    type: String,
    default: 'default',
  },
  authorization: {
    type: String,
    default: 'cjgly',
  },
});
const emit = defineEmits(['search', 'seeReport']);
// 定义 component
// 结构props
const { option, loading, dataList, modalType, modalContrast, } = toRefs(props);
// 增加 -- 子组件
const addChild = ref(null);
const editChild = ref(null);

const confirmModalConf = reactive({
  loading: false,
  visible: false,
  title: '',
  confirm: null,
  remark: '',
  callback: null,
  type: 'remark',
});
/**
 * 上传pdf文件
 */
const pdfUpload = () => {
  const { id, } = modalContrast.value ? dataList.value[0]['propInfoEntity'] : dataList.value['propInfoEntity'];

  const strId = id.toString().length >= 6 ? id : '0' + id;

  let formData = new FormData();

  let list = confirmModalConf.fileList;

  list.forEach((file) => {
    formData.append('file', file.originFileObj);
  });
  uploadReportApi(strId, formData).then((res) => {
    if (res.code === 200) {
      confirmModalConf.visible = false;
      confirmModalConf.fileList = [];
      confirmModalConf.type = '';
      message.success('上传成功！');
      message.success('删除成功！');
      bgType.value = 'yes';

      editPopup();
    }
  });
};

/**
 * @description 导入
 */
const importFileList = (data) => {
  confirmModalConf.fileList = data;
};

const prejectPrompt = ref({});
/** 新增弹窗数据 */
const addDetailRequest = {
  projectGeologyInfoEntity: {
    id: null,
    propId: null,
    propName: null,
    zoneName: null,
    avgDepthGeologicDep: null,
    geologicOreBodyType: null,
    oreMinerals: null,
    geologyComments: null,
  },
  projectGeoInfoEntity: {
    id: null,
    propId: null,
    propName: null,
    longitude: null,
    latitude: null,
    globalRegion: null,
    countryName: null,
    stateProvince: null,
    investEnvirComments: null,
    geom: null,
  },
  projectProductEntity: {
    id: null,
    propId: null,
    propName: null,
    actvStatus: null,
    mineType: null,
    startUpYear: null,
    closureYear: null,
    miningProcessingPerCost: null,
    amtCapitalInvested: null,
    capitalCostAnnouncedDate: null,
    generalComments: null,
    productInfoList: [],
  },
  projectResourceInfoEntityList: [],
  projectStockInfoEntity: {
    id: null,
    propId: null,
    propName: null,
    ownerList: null,
    ownerName: null,
    ownerPct: null,
    ownerCountry: null,
    ownerWebsite: null,
    buyer: null,
    buyerCountry: null,
    dealType: null,
    chinesePct: null,
  },
  propInfoEntity: {
    id: null,
    propName: null,
    primaryCommodity: null,
    commoditiesList: null,
    propArea: null,
    claimType: null,
    devStage: null,
    operatorName: null,
    infoSource: null,
    moYrSourceDate: null,
    propertyLevel: null,
    delete: null,
    countryName: null,
    stateProvince: null,
    parentDevStage: null,
    usedName: null,
  },
};

const projectDetailList = [
  {
    title: '基本信息',
    className: 'max',
    type: 'propInfoEntity',
    children: [
      {
        title: '项目名称',
        type: 'propName',
        editType: 'input',
        component: 'a-input',
        props: {
          placeholder: '请输入项目名称',
        },
      },
      {
        title: '主矿种',
        type: 'primaryCommodity',
        component: 'a-input',
        props: {
          placeholder: '请输入主矿种',
        },
      },
      {
        title: '全部矿种',
        type: 'commoditiesList',
        props: {
          placeholder: '请输入全部矿种',
        },
      },
      {
        title: '矿权类型',
        type: 'claimType',
        component: 'a-input',
        props: {
          placeholder: '请输入矿权类型',
        },
      },
      {
        title: '开发阶段',
        type: 'parentDevStage',
        bindType: 'devStage',
        component: 'a-input',
        props: {
          placeholder: '请输入开发阶段',
        },
      },
      {
        title: '运营商',
        type: 'operatorName',
        component: 'a-input',
        props: {
          placeholder: '请输入运营商',
        },
      },
      {
        title: '项目级别',
        type: 'propertyLevel',
        component: 'a-input',
        props: {
          placeholder: '请输入项目级别',
        },
      },
      {
        title: '项目信息来源',
        type: 'infoSource',
        component: 'a-input',
        props: {
          placeholder: '请输入项目信息来源',
        },
      },
      {
        title: '信息更新时间',
        type: 'moYrSourceDate',
        component: 'a-input',
        props: {
          placeholder: '请输入信息更新时间',
        },
      },
      {
        title: '项目面积',
        type: 'propArea',
        unit: 'k㎡',
        component: 'a-input',
        props: {
          placeholder: '请输入项目面积',
          type: 'number',
        },
      },
      {
        title: '其他名称',
        type: 'usedName',
        component: 'a-input',
        props: {
          placeholder: '请输入其他名称',
        },
      },
    ],
  },
  {
    title: '股权信息',
    className: 'max',
    type: 'projectStockInfoEntity',
    children: [
      {
        title: '股权结构',
        type: 'ownerList',
        component: 'a-textarea',
        props: {
          placeholder: '请输入股权结构',
          rows: 3,
          style: 'height: auto',
        },
      },
      {
        title: '最大持股方',
        type: 'ownerName',
        component: 'a-input',
        props: {
          placeholder: '请输入最大持股方',
        },
      },
      {
        title: '最大持股方占比',
        type: 'ownerPct',
        unit: '%',
        showTrans: true,
        component: 'a-input',
        props: {
          placeholder: '请输入最大持股方占比',
          type: 'number',
        },
      },
      {
        title: '最大持股方所属国家',
        type: 'ownerCountry',
        component: 'a-input',
        props: {
          placeholder: '请输入最大持股方所属国家',
        },
      },
      {
        title: '最大持股方公司网址',
        type: 'ownerWebsite',
        component: 'a-input',
        isLink: true,
        props: {
          placeholder: '请输入最大持股方公司网址',
        },
      },
      {
        title: '最近买家',
        type: 'buyer',
        component: 'a-input',
        props: {
          placeholder: '请输入最近买家',
        },
      },
      {
        title: '最近买家所在国',
        type: 'buyerCountry',
        component: 'a-input',
        props: {
          placeholder: '请输入最近买家所在国家',
        },
      },
      {
        title: '最近交易类型',
        type: 'dealType',
        component: 'a-input',
        props: {
          placeholder: '请输入最近交易类型',
        },
      },
      {
        title: '中国公司占股比例',
        type: 'chinesePct',
        unit: '%',
        showTrans: true,
        component: 'a-input',
        props: {
          placeholder: '请输入中国公司占股比例',
          type: 'number',
        },
      },
    ],
  },
  {
    title: '资源信息',
    className: 'max',
    type: 'projectResourceInfoEntityList',
    children: [
      {
        title: '证实储量',
        type: 'provedReserves',
        unit: 'unitMetal',
        isMineral: true,
        parentType: 'projectResourceInfoEntityList',
        showTrans: true,
        component: 'a-input',
        props: {
          placeholder: '请输入资源信息',
          type: 'number',
        },
      },
      {
        title: '证实储量品位',
        type: 'provedReservesRank',
        unit: 'unitSavour',
        isMineral: true,
        parentType: 'projectResourceInfoEntityList',
        showTrans: true,
        component: 'a-input',
        props: {
          placeholder: '请输入证实储量品位',
          type: 'number',
        },
      },
      {
        title: '可信储量',
        type: 'containedReserves',
        unit: 'unitMetal',
        isMineral: true,
        parentType: 'projectResourceInfoEntityList',
        showTrans: true,
        component: 'a-input',
        props: {
          placeholder: '请输入可信储量',
          type: 'number',
        },
      },
      {
        title: '可信储量品位',
        type: 'containedReservesRank',
        unit: 'unitSavour',
        isMineral: true,
        parentType: 'projectResourceInfoEntityList',
        showTrans: true,
        component: 'a-input',
        props: {
          placeholder: '请输入可信储量品位',
          type: 'number',
        },
      },
      {
        title: '总储量',
        type: 'sumReserves',
        unit: 'unitMetal',
        isMineral: true,
        parentType: 'projectResourceInfoEntityList',
        showTrans: true,
        className: 'bold',
        component: 'a-input',
        props: {
          placeholder: '请输入总储量',
          type: 'number',
        },
      },
      {
        title: '总储量品位',
        type: 'sumReservesRank',
        unit: 'unitSavour',
        isMineral: true,
        parentType: 'projectResourceInfoEntityList',
        showTrans: true,
        className: 'bold',
        component: 'a-input',
        props: {
          placeholder: '请输入总储量品位',
          type: 'number',
        },
      },
      {
        title: '探明资源量',
        type: 'provedResource',
        unit: 'unitMetal',
        isMineral: true,
        parentType: 'projectResourceInfoEntityList',
        showTrans: true,
        component: 'a-input',
        props: {
          placeholder: '请输入探明资源量',
          type: 'number',
        },
      },
      {
        title: '探明资源量品位',
        type: 'provedResourceRank',
        unit: 'unitSavour',
        isMineral: true,
        parentType: 'projectResourceInfoEntityList',
        showTrans: true,
        component: 'a-input',
        props: {
          placeholder: '请输入探明资源量品位',
          type: 'number',
        },
      },
      {
        title: '控制资源量',
        type: 'controlledResource',
        unit: 'unitMetal',
        isMineral: true,
        parentType: 'projectResourceInfoEntityList',
        showTrans: true,
        component: 'a-input',
        props: {
          placeholder: '请输入控制资源量',
          type: 'number',
        },
      },
      {
        title: '控制资源量品位',
        type: 'controlledResourceRank',
        unit: 'unitSavour',
        isMineral: true,
        parentType: 'projectResourceInfoEntityList',
        showTrans: true,
        component: 'a-input',
        props: {
          placeholder: '请输入控制资源量品位',
          type: 'number',
        },
      },
      {
        title: '推断资源量',
        type: 'containedResource',
        unit: 'unitMetal',
        isMineral: true,
        parentType: 'projectResourceInfoEntityList',
        showTrans: true,
        component: 'a-input',
        props: {
          placeholder: '请输入推断资源量',
          type: 'number',
        },
      },
      {
        title: '推断资源量品位',
        type: 'containedResourceRank',
        unit: 'unitSavour',
        isMineral: true,
        parentType: 'projectResourceInfoEntityList',
        showTrans: true,
        component: 'a-input',
        props: {
          placeholder: '请输入推断资源量品位',
          type: 'number',
        },
      },
      {
        title: '总资源量',
        type: 'sumResource',
        unit: 'unitMetal',
        isMineral: true,
        parentType: 'projectResourceInfoEntityList',
        showTrans: true,
        className: 'bold',
        component: 'a-input',
        props: {
          placeholder: '请输入总资源量',
          type: 'number',
        },
      },
      {
        title: '总资源量品位',
        type: 'sumResourceRank',
        unit: 'unitSavour',
        isMineral: true,
        parentType: 'projectResourceInfoEntityList',
        showTrans: true,
        className: 'bold',
        component: 'a-input',
        props: {
          placeholder: '请输入总资源量品位',
          type: 'number',
        },
      },
    ],
  },
  {
    title: '生产信息',
    className: 'max',
    type: 'projectProductEntity',
    children: [
      {
        title: '矿山状态',
        type: 'actvStatus',
        component: 'a-input',
        props: {
          placeholder: '请输入矿山状态',
        },
      },
      {
        title: '开采类型',
        type: 'mineType',
        component: 'a-input',
        props: {
          placeholder: '请输入开采类型',
        },
      },
      {
        title: '设计或实际生产开始年限',
        type: 'startUpYear',
        component: 'a-input',
        props: {
          placeholder: '请输入设计或实际生产开始年限',
        },
      },
      {
        title: '设计或实际闭坑年限',
        type: 'closureYear',
        component: 'a-input',
        props: {
          placeholder: '请输入设计或实际闭坑年限',
        },
      },
      {
        title: '项目产能',
        type: 'productionCapacity',
        parentType: 'productInfoList',
        isMineral: true,
        unit: 'unitMetal',
        showTrans: true,
        component: 'a-input',
        props: {
          placeholder: '请输入项目产能',
          type: 'number',
        },
      },
      {
        title: '去年产量',
        type: 'lastYearCapacity',
        parentType: 'productInfoList',
        isMineral: true,
        unit: 'unitMetal',
        showTrans: true,
        component: 'a-input',
        props: {
          placeholder: '请输入去年产量',
          type: 'number',
        },
      },
      {
        title: '前年产量',
        type: 'previousYearCapacity',
        parentType: 'productInfoList',
        isMineral: true,
        unit: 'unitMetal',
        showTrans: true,
        component: 'a-input',
        props: {
          placeholder: '请输入前年产量',
          type: 'number',
        },
      },
      {
        title: '开采矿石成本',
        type: 'miningProcessingPerCost',
        unit: '美元',
        showTrans: true,
        component: 'a-input',
        props: {
          placeholder: '请输入开采矿石成本',
          type: 'number',
        },
      },
      {
        title: '选矿生产成本',
        type: 'totalProductionPerCost',
        isMineral: true,
        parentType: 'productInfoList',
        unit: '美元',
        showTrans: true,
        component: 'a-input',
        props: {
          placeholder: '请输入选矿生产成本',
          type: 'number',
        },
      },
      {
        title: '资本成本',
        type: 'amtCapitalInvested',
        unit: '美元',
        showTrans: true,
        component: 'a-input',
        props: {
          placeholder: '请输入资本成本',
          type: 'number',
        },
      },
      {
        title: '资本成本发布日期',
        type: 'capitalCostAnnouncedDate',
        component: 'a-input',
        props: {
          placeholder: '请输入资本成本发布日期',
        },
      },
      {
        title: '项目概况',
        type: 'generalComments',
        component: 'a-input',
        props: {
          placeholder: '请输入项目概况',
        },
      },
    ],
  },
  {
    title: '地理信息',
    className: 'max',
    type: 'projectGeoInfoEntity',
    children: [
      {
        title: '经度',
        type: 'longitude',
        component: 'a-input',
        props: {
          placeholder: '请输入经度',
          type: 'number',
        },
      },
      {
        title: '纬度',
        type: 'latitude',
        component: 'a-input',
        props: {
          placeholder: '请输入纬度',
          type: 'number',
        },
      },
      {
        title: '项目所在大洲',
        type: 'globalRegion',
        component: 'a-input',
        props: {
          placeholder: '请输入项目所在大洲',
        },
      },
      {
        title: '项目所在国家/区域',
        type: 'countryName',
        component: 'a-input',
        props: {
          placeholder: '请输入项目所在国家/区域',
        },
      },
      {
        title: '项目所在州/省',
        type: 'stateProvince',
        component: 'a-input',
        props: {
          placeholder: '请输入项目所在州/省',
        },
      },
      {
        title: '投资环境概况',
        type: 'investEnvirComments',
        component: 'a-input',
        props: {
          placeholder: '请输入投资环境概况',
        },
      },
    ],
  },
  {
    title: '地质信息',
    className: 'max',
    type: 'projectGeologyInfoEntity',
    children: [
      {
        title: '所在成矿带名称',
        type: 'zoneName',
        component: 'a-input',
        props: {
          placeholder: '请输入所在成矿带名称',
        },
      },
      {
        title: '矿床平均埋深',
        type: 'avgDepthGeologicDep',
        component: 'a-input',
        props: {
          placeholder: '请输入矿床平均埋深',
        },
      },
      {
        title: '矿床类型',
        type: 'geologicOreBodyType',
        component: 'a-input',
        props: {
          placeholder: '请输入矿床类型',
        },
      },
      {
        title: '矿物类型',
        type: 'oreMinerals',
        component: 'a-input',
        props: {
          placeholder: '请输入矿物类型',
        },
      },
      {
        title: '地质概况',
        type: 'geologyComments',
        component: 'a-textarea',
        props: {
          placeholder: '请输入地质概况',
          rows: 3,
          style: 'height: auto',
        },
      },
    ],
  },
];

/**
 * @description 预览pdf 查看报告
 */
const previewPdf = () => {
  const { id, } = modalContrast.value ? dataList.value[0]['propInfoEntity'] : dataList.value['propInfoEntity'];
  const strId = String(id);
  if (bgType.value === 'yes') {
    // window.open(getPdfUrlApi(strId.length >= 6 ? id : '0' + strId));
    emit('seeReport', reportImgAddr, strId)
  }
};
/**
 * @description 删除报告
 */

const deleteReport = () => {
  const { id, } = modalContrast.value ? dataList.value[0]['propInfoEntity'] : dataList.value['propInfoEntity'];
  const strId = id.toString().length >= 6 ? id : '0' + id;


  removeReportApi({ fileName: strId, }).then((res) => {
    if (res.code === 200 && res.data.code === 200) {
      message.success('删除成功！');
      bgType.value = 'no';
      confirmModalConf.visible = false;

      editPopup();
    }
  });
};
const deleteConfirm = () => {
  confirmModalConf.showRemark = false;
  confirmModalConf.showUpload = true;
  confirmModalConf.title = '确定删除项目报告？';
  confirmModalConf.callback = () => deleteReport();
  confirmModalConf.visible = true;
  confirmModalConf.width = '5.4rem';
  confirmModalConf.type = 'confirm';
};
/**
 * @description 上传报告
 */
const uploadReport = () => {
  confirmModalConf.showRemark = false;
  confirmModalConf.showUpload = true;
  confirmModalConf.title = '导入';
  confirmModalConf.callback = () => pdfUpload();
  confirmModalConf.visible = true;
  confirmModalConf.width = '5.4rem';
  confirmModalConf.type = 'upload';
};

const bgMsg = () => {
  const { id, } = modalContrast.value ? dataList.value[0]['propInfoEntity'] : dataList.value['propInfoEntity'];
  const strId = String(id);
  const newId = strId.length >= 6 ? id : '0' + strId
  /**
   * 查看报告提示信息
   */

  getPdfUrlApiAjax(newId)
    .then((res) => {
      prejectPrompt.value.className = 'popup-btn';
      bgType.value = 'yes';
      getReportAddr(newId)
    })
    .catch((err) => {
      prejectPrompt.value.className = 'popup-btn bgType';
      bgType.value = 'no';
      //下面为测试使用，用完删除
      // prejectPrompt.value.className = 'popup-btn';
      // bgType.value = 'yes';
      // getReportAddr('024434') 
    });
};
/**
 * @description 跳转到钻井库
 */

const jumpDrill = () => {
  const data = modalContrast.value ? dataList.value[0] : dataList.value;

  if (data.propInfoEntity.holeFlag == '1') {

    modalDrillParams.propName = data.projectGeoInfoEntity.propName;
    modalDrillParams.propId = data.projectGeoInfoEntity.propId;
    modalDrillParams.globalRegion = data.projectGeoInfoEntity.globalRegion;
    modalDrillParams.countryName = data.projectGeoInfoEntity.countryName;

    modalTypeDrill.value = true
    // commit(null, 'setRequestParams', msg);
    // router.push({ name: '钻孔信息库入口', });
  }
};

prejectPrompt.value = {
  title: '项目报告',
  callback: previewPdf,
};
/**
 * @description 组织标题标题
 */
const getProjectTitle = (item) => {
  const { propName, countryName, primaryCommodity, } = item;

  return `${countryName}\xa0\xa0${propName}\xa0\xa0${primaryCommodity}`;
};


/**
 * @description 组合value 值
 */

const getValue = (data, i, parent) => {
  const { unitType, unit, type, parentType, isMineral, showTrans, } = i;

  let value = data[parent.type][type];
  const showValue = typeof value === 'string' || typeof value === 'number';
  const arrValue = data[parentType] || data[parent.type][parentType];
  const valueUnit = data[i.unitType];

  if (value !== null && value !== undefined && typeof Number(value) === 'number' && showTrans) {
    value = transMoney(fixedValue(value));
  }


  if (isMineral && arrValue) {
    const text = arrValue
      .map((mine) => {
        const { commodity, } = mine;

        let mineValue = mine[type];

        if (mineValue !== null && mineValue !== undefined && typeof Number(mineValue) === 'number' && showTrans) {
          mineValue = transMoney(fixedValue(mineValue));
        }

        if (!mineValue || mineValue === null) {
          return '';
        }

        return mineValue !== '0' ? `${commodity}：${mineValue}${mine[unit] ? mine[unit] : unit};` : '';
      })
      .join('');

    return text;
  }

  if (showValue && unitType) {
    return value + valueUnit;
  }

  if (showValue && unit) {
    return value + unit;
  }

  if (showValue) {
    return value;
  }

  return '';
};

const getContrast = (i, parent) => {

  if (getValue(dataList.value[0], i, parent) === getValue(dataList.value[1], i, parent)) {
    return getValue(dataList.value[0], i, parent);
  }
  let html = `<span>${getValue(dataList.value[1], i, parent)}</span> > <span style="color:red">${getValue(dataList.value[0], i, parent)}</span>`;

  return html;

};
/**
 * @description 返回
 */
const goBack = () => {
  option.value.visible = false;
};
/**
 * 钻孔库详情返回
 */
const goBackDetailMsg = () => {
  modalTypeDrill.value = false
}
/**
 * @description 自定义 value 点击事件
 */
const customValueEvent = (i, url) => {
  if (i.isLink) {
    // window.open(url);
    location.href = 'http://' + url;
  }
};

const getHref = (href) => {
  if (href.startsWith('http://') || href.startsWith('https://')) {
    return href;
  }
  return 'http://' + href;
};

/* ref **/
// 是否处于编辑状态
const showEdit = ref(false);

/**
 * @description 编辑
 */
const editPopup = () => {
  prejectPrompt.value.title = bgType.value === 'yes' ? '删除报告' : '上传报告';
  prejectPrompt.value.callback = bgType.value === 'yes' ? deleteConfirm : uploadReport;
  prejectPrompt.value.className = 'popup-btn';
  // console.log(config.getPermissionId(), 101010)
  showEdit.value = true;
};

/**
 * @description 取消编辑
 */
const editClose = () => {
  prejectPrompt.value.title = '项目报告';
  prejectPrompt.value.callback = previewPdf;
  prejectPrompt.value.className = bgType.value === 'yes' ? 'popup-btn' : 'popup-btn bgType';
  showEdit.value = false;
};

/**
 * @description 确认编辑
 */
const editConfirm = () => {
  editChild.value.editDataList['propInfoEntity'].remark = confirmModalConf.remark;
  operationSubmit({ ...editChild.value.editDataList, })
    .then((res) => {
      emit('search');
      confirmModalConf.visible = false;
      goBack();
    })
    .catch(() => {
      confirmModalConf.visible = false;
    });
};

/**
 * @description 确认新增
 */
const addConfirm = () => {
  addChild.value.editDataList['propInfoEntity'].remark = confirmModalConf.remark;
  operationSubmit({ ...addChild.value.editDataList, })
    .then((res) => {
      emit('search');
      confirmModalConf.visible = false;
      goBack();
    })
    .catch(() => {
      confirmModalConf.visible = false;
    });
};

/**
 * @description 确认新增之前
 */
const beforeAddConfirm = () => {
  confirmModalConf.title = '确认新增此条项目?';
  confirmModalConf.callback = addConfirm;
  confirmModalConf.visible = true;
};
/**
 * 修改关注状态
 * @param {关注状态} type true已关注  false 未关注
 */
const changeFollowFlag = (type) => {
  const data = modalContrast.value ? dataList.value[0] : dataList.value;
  const { id, } = data['propInfoEntity'];

  if (!type) {
    followProjectApi({ id: id, }).then((res) => {
      if (res.code === 200 && res.data.code === 200) {
        message.success('关注成功');
        data.propInfoEntity.followFlag = true;
      }
    });
  } else {
    cancelProjectApi({ id: id, }).then((res) => {
      if (res.code === 200 && res.data.code === 200) {
        message.success('取消关注成功');
        data.propInfoEntity.followFlag = false;
      }
    });
  }
};
/**
 * @description 确认编辑之前
 */
const beforeEditConfirm = () => {
  confirmModalConf.title = '确认编辑此条项目吗';
  confirmModalConf.callback = editConfirm;
  confirmModalConf.visible = true;
};

const confirm = () => {
  confirmModalConf.callback();
};

const close = () => {
  confirmModalConf.visible = false;
  confirmModalConf.type = '';
};
const getReportAddr = (id) => {
  console.log(id, 'getReportAddr')
  getReportAddrApi(id).then((res) => {
    if (res.code === 200 && res.data.code === 200) {
      console.log(res.msg)
      reportImgAddr.value = res.msg
    }
  });
}

onMounted(() => {
  // bgMsg();
  console.warn('打开');
});
watch(
  () => props.dataList,
  (newValue, oldValue) => {
    if (newValue['propInfoEntity']) {
      bgMsg();
    }
  },
  { immediate: true, }
);
</script>

<style lang="scss">
.full-modal {
  .ant-modal {
    max-width: 100%;
    height: 100%;
    // height: auto;
    // min-height: 100%;
    top: 0;
    padding-bottom: 0;
    margin: 0;

    &.max {
      height: auto;
    }
  }

  .ant-modal-content {
    display: flex;
    flex-direction: column;
    // height: calc(100vh);
    height: 100%;
    background: url('../../../static/images/projectlibrary/popup/bg_banner.png') no-repeat;
    background-size: 100% 100%;
    color: #fff;

    /* 弹窗头 */
    .ant-modal-header {
      border: none;
      background: none;
      color: #fff;

      .ant-modal-title {
        color: #fff;
        font-size: 0.2rem;
      }
    }

    /* 弹窗内容 */
    .ant-modal-body {
      padding: 0.2rem 1rem;

      .ant-spin {
        position: absolute;
        top: 50%;
        left: 50%;
      }

      .ant-spin-nested-loading {
        width: 100%;
        height: 100%;

        .ant-spin-container {
          width: 100%;
          height: 100%;
          overflow: unset;
        }

        .ant-spin {
          max-height: 100%;
        }

        .ant-spin-blur::after {
          opacity: 0;
        }
      }

      /* 弹窗按钮 返回等 */
      .popup-btns {
        position: fixed;
        top: 0.29rem;
        right: 1rem;
        display: flex;
        align-items: center;
        z-index: 500;

        /* 返回按钮 */
        .popup-btn {
          margin-right: 0.4rem;
          padding: 0.08rem 0.34rem;
          background: url('../../../static/images/projectlibrary/popup/bg_back.png') no-repeat;
          background-size: 100% 100%;
          font-size: .14rem;
          font-family: Microsoft YaHei;
          font-weight: 600;
          color: #5b1801 !important;
          cursor: pointer;
        }

        .bgType {
          cursor: not-allowed;
          opacity: 0.5;
        }
      }

      /* 内容头 */
      .popup-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 0.7rem;
        margin: 0.3rem 0;

        .popup-header-title {
          display: flex;
          align-items: center;
          padding: 0.2rem 0.04rem 0.2rem 0.2rem;
          background: url('../../../static/images/projectlibrary/popup/bg_title.png') no-repeat;
          background-size: 100% 100%;

          .popup-header-title-name {
            font-size: 0.28rem;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ffffff;
          }

          .popup-header-title-project {
            margin-left: 0.2rem;
            padding: 0.04rem 0.5rem 0.04rem 0.12rem;
            font-size: 0.16rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffc300;
            background: url('../../../static/images/projectlibrary/popup/bg_xm.png') no-repeat;
            background-size: 100% 100%;
          }
        }
      }

      /* 内容主体 */
      .popup-content {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        &.edit {
          .popup-item {

            /* 下拉框 */
            .ant-select-selector {
              height: 0.4rem;

              .ant-select-selection-placeholder,
              .ant-select-selection-item {
                padding-right: 0;
                line-height: 0.4rem;
              }
            }

            ul {
              height: 70%;

              li {
                padding-right: 0.2rem;

                .value {
                  flex: 1;
                }
              }
            }

            /* 生产信息 */
            .product-entity-content {
              height: 70%;
              overflow: auto;

              .product-entity {
                .ant-tabs-content {
                  height: 1.5rem;

                  ul {
                    height: auto;
                  }
                }
              }

              ul {
                height: auto;
              }
            }

            .edit-tabs {
              .ant-tabs-tab {
                color: #fff;
              }

              .ant-tabs-tab:hover {
                color: #ffd752;
              }

              .ant-tabs-tab-active {
                color: #ffc428;
                text-shadow: 0 0 0.0025rem currentColor;
              }

              .ant-tabs-tab-arrow-show {
                color: #fff;
              }

              ul {
                height: 59%;
              }
            }

            &.max {

              /* 列表 */
              ul {
                li {
                  .value {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 10;

                    // 全部矿种
                    .commoditiesList {
                      .btn {
                        margin: 0.05rem;
                      }
                    }
                  }
                }
              }
            }
          }

          /** 下拉框 */
          .ant-select {
            .ant-select-arrow {
              color: #fff;
            }

            // 背景
            &:not(.ant-select-customize-input) .ant-select-selector {
              background-color: rgba(91, 76, 39, 0.4);
              border-color: rgba(91, 76, 39, 1);
              color: #fff;
            }

            .ant-select-selection-search-input {
              height: 100%;
            }

            .ant-select-selection-placeholder {
              line-height: 0.4rem;
              font-size: 0.16rem;
            }

            /* 描述 */
            // .ant-select-selection-placeholder {
            //   color: #fff;
            // }
          }

          .ant-input {
            height: 0.4rem;
            color: white;
            background-color: rgba(91, 76, 39, 0.4);
            border-color: rgba(91, 76, 39, 1);
            // font-size: 0.14rem;
            font-family: Microsoft YaHei;
          }
        }

        .popup-item {
          position: relative;
          width: 8.33rem;
          margin-bottom: 0.3rem;
          padding: 0 0.5rem;
          // padding-top: .4rem;
          background: url('../../../static/images/projectlibrary/popup/bg_item.png') no-repeat;
          background-size: 100% 100%;

          &.default {
            height: 3.42rem;
            padding-top: 0.4rem;
          }

          /* 列表 */
          ul {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            overflow: auto;

            li {
              display: flex;
              align-items: center;
              width: 48%;
              margin: 0.05rem 0;

              .title,
              .value {
                font-size: 0.18rem;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #b3b1aa;
                word-break: break-all;

                &.bold {
                  color: #fff;
                  font-weight: bold;
                }
              }

              .title {
                white-space: nowrap;
              }

              .value {
                color: #d8d5c9;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;

                .ant-tooltip-content {
                  max-height: 3rem;
                  overflow-x: hidden;
                  overflow-y: auto;
                }
              }
            }
          }

          &.max {
            height: 4.12rem;
            padding-top: 0.4rem;
            background-size: 100% 95%;

            /* 列表 */
            ul {
              li {
                .value {
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 1;
                }
              }
            }
          }

          /* 标题 */
          h4 {
            font-size: 0.24rem;
            font-family: PangMenZhengDao;
            font-weight: 400;
            color: #faf8f5;
            margin: 0.15rem 0;
          }

          /* 右上角索引 */
          .popup-index {
            position: absolute;
            width: 1.56rem;
            height: 0.62rem;
            top: 0.41rem;
            right: 0.4rem;
            background: url('../../../static/images/projectlibrary/popup/bg_line.png') no-repeat;
            background-size: 100% 100%;

            span {
              position: absolute;
              left: 0.5rem;
              bottom: 0;
              font-size: 0.48rem;
              font-family: Avenir;
              font-weight: normal;
              color: #ffffff;
              line-height: 0.8;
            }
          }
        }
      }

      /** 底部按钮 */
      .popup-bottom-btns {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 0.3rem;
        z-index: 500;

        .popup-btn {
          margin-right: 0.4rem;
          padding: 0.08rem 0.34rem;
          background: url('../../../static/images/projectlibrary/popup/bg_back.png') no-repeat;
          background-size: 100% 100%;
          font-size: .14rem;
          font-family: Microsoft YaHei;
          font-weight: 600;
          color: #5b1801 !important;
          cursor: pointer;
        }

        .bgType {
          cursor: not-allowed;
          opacity: 0.5;
        }
      }
    }
  }

  .ant-modal-body {
    flex: 1;
  }

  .drill-table {
    width: 100%;
    height: 100%;
  }
}
.zIndex600{
  z-index:600 !important;
}
</style>
